import { render, staticRenderFns } from "./HowThisWorks.vue?vue&type=template&id=7c3bbe7c&lang=pug&"
import script from "./HowThisWorks.vue?vue&type=script&lang=js&"
export * from "./HowThisWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports